// extracted by mini-css-extract-plugin
export default {"samsungPayButton":"SamsungPayButton_samsungPayButton__GpHQ1"};